import { Timestamp, WhereFilterOp } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';

import { functions } from '../Firebase';

export interface Pagination {
  offset: number;
  limit: number;
}

export type FilteringItem = {
  value: string | number | Timestamp;
  operation: WhereFilterOp;
  attribute: string;
};

interface PayoutsRequestOptions {
  pagination?: Pagination;
  ordering?: string[];
  filtering?: FilteringItem[];
}

interface AdminUpdatePayout {
  id: string;
  status?: 'requested' | 'rejected' | 'pending' | 'approved' | 'completed';
  approvedAmount?: number;
  payoutMethod?: string;
  answer?: string;
}

export const fetchPayouts = async (options?: PayoutsRequestOptions) => {
  const payouts = httpsCallable(functions, 'adminPayoutsFetch');

  return await payouts(options);
};

export const updatePayout = async (data: AdminUpdatePayout) => {
  const req = httpsCallable(functions, 'adminUpdatePayout');

  return await req(data);
};

export const fetchPayoutById = async (id: string) => {
  const req = httpsCallable(functions, 'adminPayoutsFetchById');

  return await req(id);
};

export type PayoutRequest = {
  /** Only meant for admin to be used on admin panel. */
  artistId?: string;
  requestedAmount: number;
};

export const requestPayout = httpsCallable<PayoutRequest, void>(functions, 'requestPayout');
